<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="width"
      :before-close="handleCloseRight"
      :close-on-click-modal="closeOnClickModal"
      @opened="opened"
      append-to-body
      :custom-class='className'
      >
        <slot name="content"></slot>
        <span slot="footer" class="dialog-footer" v-show="isShowFooter">
          <el-button class="btn-hover" v-if="isShowCancelBtn" size="small" @click="handleClose">{{cancelBtnText}}</el-button>
          <el-button class="btn-hover" v-if="isShowSureBtn" size="small" type="primary" :loading="btnLoading" @click="onSure">{{sureBtnText}}</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'w-dialog',
  props: {
    isShowCancelBtn: {
      type: Boolean,
      default: true
    },
    isShowSureBtn: {
      type: Boolean,
      default: true
    },
    btnLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '30%'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    isShowFooter: {
      type: Boolean,
      default: true
    },
    sureBtnText: {
      type: String,
      default: '确 定'
    },
    cancelBtnText: {
      type: String,
      default: '取 消'
    },
    title: {
      type: String,
      default: '提示'
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    handleClose(type) {
      this.$emit('handleClose', true)
    },
    handleCloseRight() {
      this.$emit('handleCloseRight', true)
    },
    onSure() {
      this.$emit('onSure')
    },
    onShowDialog() {
      this.dialogVisible = true
    },
    onCloseDialog() {
      this.dialogVisible = false
    },
    opened() {
      this.$emit('opened')
    }
  }
}
</script>

<style lang="less">
  .list-text-box {
    padding: 0 12px;
    ul+ul {
      margin-top: 10px;
    }
    li {
      font-size:14px;
      color:rgba(0,0,0,0.45);
      line-height: 2;
      span:last-child {
        color:rgba(0,0,0,0.85);
      }
    }
  }
  .btn-hover:hover {
    border-color: #40bdbd; /* 鼠标悬浮时改变边框颜色 */
  }
</style>
